import { isDefined } from "Utils/functions";

type GenericFunction<P extends Array<any>> = (...params: P) => any;

export function getDebounce(
  delay = 300,
): <P extends Array<any>>(f: GenericFunction<P>, ...params: P) => void {
  let timer: NodeJS.Timeout | undefined;

  return <P extends Array<any>>(f: GenericFunction<P>, ...params: P): void => {
    if (isDefined(timer)) {
      clearTimeout(timer);
    }

    timer = setTimeout(() => {
      f(...params);
      timer = undefined;
    }, delay);
  };
}
